import { addYears } from 'date-fns';
import * as React from 'react';
import { DayPicker, DayPickerProps, DateRange } from 'react-day-picker';
import 'react-day-picker/style.css';
import OutsideClickHandler from 'react-outside-click-handler';
import { IDatePickerComponentProps } from './datepicker';
import * as S from './datepicker.styles';

interface IDatePickerRangeProps {
    /**
     * If renderComponent is passed, then we render popover with datepicker
     * If not, then we just render datepicker
     */
    renderComponent?: (props: IDatePickerComponentProps) => React.ReactElement;
    onDateRangeSelected?: (from: Date, to: Date) => void;
    format?: string;
    from?: Date;
    to?: Date;
}

interface IDatePickerRangeState {
    from: Date | undefined;
    to: Date | undefined;
    enteredTo: Date | undefined;
}


export class DatePickerRange extends React.Component<IDatePickerRangeProps, IDatePickerRangeState> {

    constructor(props: IDatePickerRangeProps) {
        super(props);
        this.state = this.getInitialState(props.from, props.to);
    }

    public render(): React.ReactElement {
        const { from, enteredTo } = this.state;

        const selectedRange: DateRange | undefined = from ? {
            from,
            to: enteredTo,
        } : undefined;

        const disabledDays = from ? {
            before: from,
            // Forbid to select more than 1 year range
            after: addYears(from, 1),
        } : undefined;

        const dayPickerProps: DayPickerProps = {
            mode: "range",
            selected: selectedRange,
            disabled: disabledDays,
            onSelect: this.handleSelect,
            onDayMouseEnter: this.handleDayMouseEnter,
            showOutsideDays: true,
            // navbarElement: this.renderNavbarElement, // Not available in v9
            defaultMonth: from,
        };


        return (
            <S.DatePickerWrapper>
                <OutsideClickHandler onOutsideClick={this.hideDayPicker}>
                    <DayPicker {...dayPickerProps} />
                </OutsideClickHandler>
            </S.DatePickerWrapper>
        );
    }

    private handleSelect = (range: DateRange | undefined): void => {
        if (!range?.from) {
            this.resetState();
            return;
        }

        const { from, to } = range;
        if (to) {
            this.setState({
                from,
                to,
                enteredTo: to,
            });

            if (this.props.onDateRangeSelected) {
                this.props.onDateRangeSelected(from, to);
            }
        } else {
            this.setState({
                from,
                to: undefined,
                enteredTo: undefined,
            });
        }
    };

    private handleDayMouseEnter = (day: Date): void => {
        const { from, to } = this.state;
        if (from && !to) {
            this.setState({
                enteredTo: day,
            });
        }
    };

    private hideDayPicker = (): void => {
        // No longer needed with DayPicker only
    };

    private resetState = (): void => {
        this.setState(this.getInitialState());
    };

    private getInitialState = (from?: Date, to?: Date): IDatePickerRangeState => {
        return {
            from,
            to,
            enteredTo: to, // Keep track of the last day for mouseEnter.
        };
    };
}
